<script setup>
defineProps({
  isDisabled: {
    type: Boolean,
    default: false,
  }
}); 
</script>

<template>
  <div
    class="globus-button-secondary"
    :class="{'globus-button-secondary_disabled': isDisabled}"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">

.globus-button-secondary {
  display: flex;
  justify-content: center;
  align-items: center;
  background: $globus-button-secondary-color;
  color: $globus-button-secondary-text-color;
  border-radius: 8px;
  gap: 4px;
  padding: 6px 15px 6px 15px;
  height: 42px;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: $globus-button-secondary-hover-text-color;
    background-color: $globus-button-secondary-hover-color;
  }

  &_disabled {
    cursor: not-allowed;
    background: $globus-button-secondary-disabled-color;

    &:hover {
      background: $globus-button-secondary-disabled-color;
    }
  }
}
</style>
